import { useTheme } from '@mui/material/styles';
function NRCircleMediumIcon({ height = '24', width = '24', color }) {
  const theme = useTheme();
  const iconColor = color || theme.palette.severityPalette[3].main;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
        fill={iconColor}
      />
      <path d="M7.99998 14.9999L16 14.9999V12.9999L7.99998 12.9999V14.9999ZM16 8.99994L7.99998 8.99994V10.9999H16L16 8.99994Z" fill={iconColor} />
    </svg>
  );
}

export default NRCircleMediumIcon;
